export default "__VITE_ASSET__CUTwXBxV__"